<tt-page *ngIf="!!edit">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <div *ngIf="custactMemberKeyno === '0'">
            <tt-input *ngIf="edit.pers_no === '0'" ttLabel="pers_no" [ttModel]="edit.pers_no" ttReadonly></tt-input>
            <tt-input *ngIf="edit.pers_no !== '0'" ttLabel="pers_no" [ttModel]="edit.pers_no" ttReadonly [ttButtons]="personButtons"></tt-input>
            <tt-search ttLabel="pers_name" [(ttModel)]="edit.pers_name" [ttSearch]="searchPersonNames" (ttOnSelected)="onPersonNameSelected($event)" (ttOnClear)="onPersonNameSelected()"></tt-search>
        </div>

        <div *ngIf="custactMemberKeyno !== '0'">
            <tt-input *ngIf="edit.portal_user_keyno !== '0'" ttLabel="user_name" [ttModel]="edit.user_name" ttReadonly></tt-input>
            <tt-input *ngIf="edit.pers_no !== '0'" ttLabel="pers_name" [ttModel]="edit.pers_name" ttReadonly [ttButtons]="personButtons"></tt-input>
        </div>

        <tt-input *ngIf="edit.cust_no !== '0'" ttLabel="cust_name" [ttModel]="edit.cust_name" ttReadonly [ttButtons]="customerNameButtons"></tt-input>
        <tt-checkbox ttLabel="advising" [(ttModel)]="edit.advising"></tt-checkbox>
        <tt-checkbox ttLabel="contributing" [(ttModel)]="edit.contributing"></tt-checkbox>
        <tt-checkbox ttLabel="executer" [(ttModel)]="edit.executer"></tt-checkbox>
        <tt-checkbox ttLabel="inform" [(ttModel)]="edit.inform"></tt-checkbox>
        <tt-checkbox ttLabel="responsible" [(ttModel)]="edit.responsible"></tt-checkbox>
        <tt-textarea ttLabel="note" [(ttModel)]="edit.note"></tt-textarea>
        <tt-button-save ttText="save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
        <tt-button *ngIf="custactMemberKeyno !== '0'" ttText="delete" (ttClick)="deleteValues()" ttIcon="fas fa-trash-alt" ttType="danger" [ttLoading]="deleting"></tt-button>
    </tt-card>
</tt-page>
